import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TAWK_SCRIPT_ID = "tawk-to-script";
const TAWK_SRC = "https://embed.tawk.to/6a5565aff9a2241d47e6e567/1jtepae2j";

/** Routes hors partie client (pas de chat Tawk). */
function isNonClientRoute(pathname) {
  if (pathname.startsWith("/dashboard")) return true;
  if (pathname.startsWith("/admin-dashboard")) return true;
  if (pathname.startsWith("/vendor")) return true;
  if (pathname === "/forgot-password") return true;
  // /reset-password/:token = vendeur ; /reset-password (sans token) = client
  if (/^\/reset-password\/.+/.test(pathname)) return true;
  return false;
}

function showTawk() {
  if (typeof window.Tawk_API?.showWidget === "function") {
    window.Tawk_API.showWidget();
  }
}

function hideTawk() {
  if (typeof window.Tawk_API?.hideWidget === "function") {
    window.Tawk_API.hideWidget();
  }
}

function ensureTawkScript() {
  if (typeof window === "undefined") return;

  // Tawk_API doit exister AVANT le chargement du script
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = window.Tawk_LoadStart || new Date();

  if (document.getElementById(TAWK_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = TAWK_SCRIPT_ID;
  script.async = true;
  script.src = TAWK_SRC;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");

  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.body.appendChild(script);
  }
}

/**
 * Widget Tawk.to — une seule instance (Router).
 * Visible uniquement sur les pages client.
 */
const TawkToWidget = () => {
  const { pathname } = useLocation();
  const shouldShow = !isNonClientRoute(pathname);

  useEffect(() => {
    ensureTawkScript();

    const applyVisibility = () => {
      if (shouldShow) {
        showTawk();
      } else {
        hideTawk();
      }
    };

    // Si déjà chargé
    if (window.Tawk_API && typeof window.Tawk_API.showWidget === "function") {
      applyVisibility();
      return undefined;
    }

    // Sinon attendre onLoad (enchaîner un éventuel callback existant)
    const previousOnLoad = window.Tawk_API.onLoad;
    window.Tawk_API.onLoad = function onTawkLoad() {
      if (typeof previousOnLoad === "function") {
        previousOnLoad();
      }
      applyVisibility();
    };

    // Filet de sécurité si onLoad a déjà été déclenché
    const timeoutId = window.setTimeout(() => {
      if (typeof window.Tawk_API?.showWidget === "function") {
        applyVisibility();
      }
    }, 1500);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [shouldShow]);

  return null;
};

export default TawkToWidget;
